import { AppContext, AppAction } from "helpers/context";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as RecentEventsSvg } from "assets/icon_recent_events.svg";
import styles from "./recent-events.module.scss";
import { getEventList } from "api/layer"
import { CircularProgress, Card } from "@mui/material";
import dayjs from "dayjs";
import { LeftPanel } from "helpers/constants";
import TryAgain from "components/tryAgain/tryAgain";

function RecentEvents() {
  const [context, dispatch] = useContext(AppContext);
 const [t] = useTranslation();
  const [recentEventList, setRecentEventList] = useState<any[]>([]);
  const [typeCount, setTypeCount] = useState([]);
  const [isLoading, setIsLoading] = useState(1); // 1 初始化 2 加载中 3 加载成功 4 加载失败

  const handleLoadEvents = () => {
    setIsLoading(2);
    getEventList({
      fromDateTime: dayjs("1876-01-01").format("YYYY-MM-DD"),
      toDateTime: dayjs(new Date()).format("YYYY-MM-DD"),
      longitude: context.currentMultipleLocationInfo ? context.currentMultipleLocationInfo.longitudeWgs : context.searchLocationInfo.en.location.split(",")[0],
      latitude: context.currentMultipleLocationInfo ? context.currentMultipleLocationInfo.latitudeWgs : context.searchLocationInfo.en.location.split(",")[1],
      country: context.currentMultipleLocationInfo ? context.currentMultipleLocationInfo.country : context.searchLocationInfo.en.country,
      oversea: context.currentMultipleLocationInfo ? true : context.searchLocationInfo.en.oversea,
      spatial: context.currentMultipleLocationInfo ? "wgs" : context.searchLocationInfo.en.spatial,
    }).then((res: any) => {
      if (res && res.code === 200) {
        let list = res.data?.events || [];
        let arr: any = [];
        list = list.map((item: any) => {
          if (item.type && !arr.includes(item.type)) {
            arr.push(item.type);
          }
          let isFind = context.selectedEventsList.find((e) => e.id === item.id);
          if (isFind) {
            item.checked = true;
            item.opacity = isFind.opacity;
            item.layerObj = isFind.layerObj;
          } else {
            item.checked = false;
            item.opacity = 0.5;
          }
          return item
        });
        setTypeCount(arr);
        setRecentEventList(list);
        setIsLoading(3);
      } else {
        setIsLoading(4);
      }
    }).catch(() => {
      setIsLoading(4);
    })
  }

  const handleSetEvents = () => {
    dispatch({
      type: AppAction.setEventsFilterForm,
      payload: {
        fromDateTime: dayjs("1876-01-01").format("YYYY-MM-DD"),
        toDateTime: dayjs(new Date()).format("YYYY-MM-DD"),
        isShowAll: true,
        type: ["Cyclone", "Winterstorm", "Earthquake", "Flood", "Rainfall"],
        longitude: context.currentMultipleLocationInfo ? context.currentMultipleLocationInfo.longitudeWgs : context.searchLocationInfo.en.location.split(",")[0],
        latitude: context.currentMultipleLocationInfo ? context.currentMultipleLocationInfo.latitudeWgs : context.searchLocationInfo.en.location.split(",")[1],
        country: context.currentMultipleLocationInfo ? context.currentMultipleLocationInfo.country : context.searchLocationInfo.en.country,
        oversea: context.currentMultipleLocationInfo ? true : context.searchLocationInfo.en.oversea,
        spatial: context.currentMultipleLocationInfo ? "wgs" : context.searchLocationInfo.en.spatial,
        locationInfo: context.currentMultipleLocationInfo ?? context.searchLocationInfo,
        isNotRequest: true,
      }
    });
    dispatch({ type: AppAction.setEventsList, payload: recentEventList })
    dispatch({ type: AppAction.setLeftPanel, payload: LeftPanel.Events });
  }

  const handleGetEventTypes = () => {
    let str = "";
    typeCount.forEach((item: any, index: number) => {
      if (index === typeCount.length - 1) {
        str += t("events." + item);
      } else {
        str += t("events." + item) + ", ";
      }
    })
    return str
  }

  useEffect(() => {
    setIsLoading(1);
  }, [context.currentMultipleLocationInfo, context.searchLocationInfo])

  return (<div className={styles.layers}>
    <div className={styles.header}>
      <div className={styles.icon}>
        <RecentEventsSvg />
      </div>
      <div>{t("events.Recent Events")}</div>
      <div className={styles.count}>
        {(isLoading === 1 || isLoading === 4) && <button className={styles.buttons} onClick={handleLoadEvents}>{t("events.loadEvents")}</button>}
        {isLoading === 2 && <div className="flex items-center"><CircularProgress color="success" size="14px" style={{ marginRight: "5px" }} />{t("layers.loading")}</div>}
        {isLoading === 3 && <span style={{ color: typeCount.length === 0 ? "#0009" : "#cccccc", fontSize: "12px" }}>{typeCount.length === 0 ? t("events.noEvents") : t("events.eventTypes", { num: typeCount.length })}</span>}
      </div>
    </div>
    {isLoading === 4 && <TryAgain handleRetry={handleLoadEvents} />}
    {isLoading === 3 && typeCount.length !== 0 && <Card
      variant="outlined"
      style={{
        borderRadius: "4px",
        marginTop: "15px",
        marginBottom: "15px",
        marginLeft: "10px",
        border: "1px solid var(--Surface-Border---Outline, rgba(33, 33, 33, .12))",
        background: "#fff",
        boxShadow: "0 1px 6px #0000001f, 0 1px 4px #0000001f",
      }}
    >
      <div className="flex items-center p-[16px]">
        <div className="text-[#000000de] text-[14px] font-medium mr-[20px] flex-1">{handleGetEventTypes()}</div>
        <button
          className={styles.buttons}
          onClick={handleSetEvents}
        >
          {t("events.showEvents")}
        </button>
      </div>
    </Card>}

  </div >);
}

export default RecentEvents;

